import { EditorJSONState } from '../editor/types';

export const DEFAULT_KEYMAP_INPUTRULE_PRIORITY = 40;
export const EMPTY_SELECTION = Object.seal({
  type: 'text',
  anchor: 0,
  head: 0,
});

export const isEmptyDoc = (state: EditorJSONState) => {
  if (!state?.doc?.content?.length) return true;

  const { content: docContent } = state.doc;
  return docContent.length === 1 && (!docContent[0].content || !docContent[0].content.length);
};
